/* eslint-disable class-methods-use-this */
import axios from "axios"
import LogsApi from "../API/logs"
import { Service } from "./Service"

class SystemService extends Service {
    private static instance: SystemService

    constructor() {
        super()
        // set le nom du service
        this.name = "SystemService"
        // ajoute la methode du service dans le mapping du site
        this.serviceMap.push({ key: "getLogs", fct: this.getLogs })
    }

    /*
     * Récupération de l'instance
     */
    public static getInstance(): SystemService {
        if (!this.instance) {
            this.instance = new SystemService()
        }
        return this.instance
    }

    /**
     * Revoi les inforamtions du server backend
     * @returns {"env":"xxx","desc":"xxx","version":"x.x.x"} | null
     */
    public async getInfo(): Promise<{
        env: string
        desc: string
        version: string
    } | null> {
        const serverBaseURL = process.env.REACT_APP_API_BASE_URL
        if (serverBaseURL) {
            const response = await axios.get(`${serverBaseURL}/`)
            return response.data?.version
        }
        return null
    }

    /**
     * @param  { "raw" | "html" } format a recup
     * @return {Promise<any>}
     */
    public getLogs(format: string): Promise<any> {
        return LogsApi.getLogs(format)
    }
}

export default SystemService
